<template>
  <b-modal ref="mdlConfigurazioneParametroVitale" :title="title" centered no-close-on-backdrop no-close-on-esc hide-header-close size="xl">
    <b-row>
      <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
        <label class="sa-label-data">Descrizione</label>
        <b-form-input v-model="jsonData.descrizione" required> </b-form-input>
      </b-col>
      <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
        <label class="sa-label-data">Numero Valori</label>
        <b-form-input type="number" disabled v-model="jsonData.numeroValori" required></b-form-input>
      </b-col>
      <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
        <label class="sa-label-data">Ausilio</label>
        <b-form-select v-model="jsonData.ausilio" :options="ausilioOptions" value-field="voce" text-field="voce" value="''" required>
          <template #first>
            <b-form-select-option :value="null"> - Seleziona Ausilio - </b-form-select-option>
          </template>
        </b-form-select>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
        <b-table sticky-header ref="table" stacked="sm" striped hover :items="jsonData.listaMisurazioni" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
          <template #cell(misura)="item">
            <span v-if="item.index !== jsonData.listaMisurazioni.length - 1">{{ getLabelTraduora(item.item.misura) }}</span>
            <b-form-select v-if="item.index === jsonData.listaMisurazioni.length - 1" :options="misurazioniTipiOptions" v-model="item.item.misura" value-field="value" text-field="text" :value="null"></b-form-select>
          </template>
          <template #cell(valoreMinimo)="item">
            <span v-if="item.index !== jsonData.listaMisurazioni.length - 1">{{ item.item.valoreMinimo }}</span>
            <b-form-input v-if="item.index === jsonData.listaMisurazioni.length - 1" type="number" v-model="item.item.valoreMinimo"></b-form-input>
          </template>
          <template #cell(valoreMassimo)="item">
            <span v-if="item.index !== jsonData.listaMisurazioni.length - 1">{{ item.item.valoreMassimo }}</span>
            <b-form-input v-if="item.index === jsonData.listaMisurazioni.length - 1" type="number" v-model="item.item.valoreMassimo"></b-form-input>
          </template>
          <template #cell(actions)="row">
            <b-button v-if="row.index === jsonData.listaMisurazioni.length - 1" size="sm" variant="btn btn-outline-success waves-effect waves-light width-sm no-text" @click="onAdd(jsonData.listaMisurazioni, row.item)">
              <b-icon icon="plus"></b-icon>
            </b-button>
            <b-button v-if="row.index !== jsonData.listaMisurazioni.length - 1" size="sm" variant="btn btn-outline-danger waves-effect waves-light width-sm no-text" @click="onDelete(jsonData.listaMisurazioni, row)">
              <b-icon icon="trash"></b-icon>
            </b-button>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <template #modal-footer>
      <b-button variant="outline-danger" @click="onCloseModal">Annulla</b-button>
      <b-button variant="outline-success" @click="onClickSaveConfigurazioneParametriVitali()">Salva</b-button>
    </template>
    <modal-error ref="cmpModalError"></modal-error>
  </b-modal>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import ModalError from "../../../../template/components/modal/components/ModalError.vue";

export default {
  mixins: [UtilityMixin],
  components: {
    ModalError,
  },

  watch: {
    "jsonData.listaMisurazioni": function (params) {
      if (params) {
        this.jsonData.numeroValori = params.length - 1;
      }
    },
  },
  data() {
    return {
      pathResource: "/rsaconfigurazioneparametrivitali",
      pathResourceDizionario: "/rsadizionario",
      pathResourceMisurazioni: "/pazientemisuretipi",
      perPage: 10000000,
      currentPage: 1,
      id: null,
      title: null,
      listKey: 0,
      jsonData: {
        id: null,
        descrizione: null,
        numeroValori: null,
        ausilio: null,
        listaMisurazioni: [],
      },
      ausilioOptions: [],
      misurazioniTipiOptions: [],
      fields: [
        { label: "Misura", key: "misura" },
        { label: "Valore Minimo", key: "valoreMinimo" },
        { label: "Valore Massimo", key: "valoreMassimo" },
        { class: "sa-table-column-action-double", label: "", key: "actions" },
      ],
    };
  },
  mounted() {
    // let me = this;
    // me.loadDizionarioData();
    // me.loadMisurazioni();
  },
  methods: {
    // show(jsonData) {
    //     let me = this;
    //     me.jsonData = jsonData;
    //     me.title = !jsonData.id ? "Nuovo Parametro Vitale" : "Modifica Parametro Vitale";
    //     me.$refs.mdlConfigurazioneParametroVitale.show();
    // },
    setId(id) {
      let me = this;
      me.id = id;
      me.loadDizionarioData();
      me.loadMisurazioni();
      if (id === null) {
        me.jsonData = { id: null, descrizione: null, numeroValori: null, ausilio: null, listaMisurazioni: [] };
        me.jsonData.listaMisurazioni.push({ misura: null, valoreMassimo: 0, valoreMinimo: 0 });
      } else {
        me.loadData();
      }

      me.$refs.mdlConfigurazioneParametroVitale.show();
    },
    loadData() {
      let me = this;
      let path = process.env.VUE_APP_PATH_API + me.pathResource + "/" + me.id;
      UtilityMixin.methods.restCallGet(path, null, me.loadDataSuccess, me.loadDataError);
    },
    loadDataSuccess(response) {
      let me = this;
      me.jsonData = response.data.data;
      // console.log(me.jsonData);

      me.jsonData.listaMisurazioni.push({ misura: null, valoreMassimo: 0, valoreMinimo: 0 });
    },
    loadDataError(error) {
      console.log("Errore nel caricamento dei parametri vitali", error);
    },
    loadDizionarioData() {
      let me = this;
      UtilityMixin.methods.loadDataResources(me.pathResourceDizionario, null, me.loadDizionarioDataSuccess, me.loadDizionarioDataError);
    },
    loadDizionarioDataSuccess(response) {
      let me = this;
      if (response.data?.data?.list) {
        me.ausilioOptions = response.data.data.list.filter((item) => item.tipo === "AUSILIO_PARAM_VITALI");
      }
    },
    loadDizionarioDataError(error) {
      console.log("Errore nel caricamento degli ausili", error);
    },
    loadMisurazioni() {
      let me = this;
      me.misurazioniTipiOptions = [];
      UtilityMixin.methods.loadDataResources(me.pathResourceMisurazioni, null, me.loadMisurazioniDataSuccess, me.loadMisurazioniDataError);
      // console.log("Debug", me.jsonData);
    },
    loadMisurazioniDataSuccess(response) {
      let me = this;
      // console.log(response);

      response.data.data.forEach((element) => {
        me.misurazioniTipiOptions.push({ text: this.getLabelTraduora(element.descrizione), value: element.misura });
      });
      me.misurazioniTipiOptions.unshift({ value: null, text: "-Seleziona Valore-" });
    },
    loadMisurazioniDataError(error) {
      console.log("Errore nel caricamento dei tipi", error);
    },
    onCloseModal() {
      let me = this;
      me.jsonData = { id: null, descrizione: null, numeroValori: null, ausilio: null, listaMisurazioni: [{ misura: null, valoreMassimo: 0, valoreMinimo: 0 }] };
      me.$refs.mdlConfigurazioneParametroVitale.hide();
      me.$emit("onCloseModal");
    },
    onClickSaveConfigurazioneParametriVitali() {
      let me = this;
      UtilityMixin.methods.saveResource(me.pathResource, me.jsonData, me.saveConfigurazioneParametriVitaliSuccess, me.saveConfigurazioneParametriVitaliError);
    },
    saveConfigurazioneParametriVitaliSuccess(response) {
      let me = this;
      me.$emit("onSaveParametroVitale", response);
      me.$refs.mdlConfigurazioneParametroVitale.hide();
      me.$bvToast.toast("Salvataggio avvvenuto con successo", {
        title: "Success",
        variant: "success",
        solid: true,
      });
    },
    saveConfigurazioneParametriVitaliError(error) {
      let me = this;
      me.$refs.cmpModalError.show(error.response.data.messaggio);
    },

    onAdd(array, value) {
      if (value.misura) {
        array.push({ misura: null, valoreMassimo: 0, valoreMinimo: 0 });
      } else {
        this.$bvModal
          .msgBoxOk("Il campo Misura e' OBBLIGATORIO", {
            title: "ATTENZIONE",
            size: "sm",
            okVariant: "outline-danger",
            headerClass: "sa-msg-header-danger",
            footerClass: "p-2 border-top-0",
            centered: true,
          })
          .then(() => {
            // console.log(value);
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    onDelete(array, row) {
      if (row.index != array.length) {
        this.$bvModal
          .msgBoxConfirm("Sicuro di voler procedere alla cancellazione?", {
            title: "Titolo",
            buttonSize: "sm",
            okVariant: "secondary",
            cancelVariant: "danger",
            okTitle: "SI",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          })
          .then((value) => {
            if (value) {
              array.splice(row.index, 1);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    onDeleteParametroVitale(item) {
      let me = this;
      me.$bvModal
        .msgBoxConfirm("Sei sicuro di eliminare questo parametro vitale?", {
          title: "Eliminazione Parametro Vitale",
          buttonSize: "sm",
          okTitle: "SI",
          cancelTitle: "NO",
          okVariant: "danger",
          cancelVariant: "secondary",
          hideHeaderClose: true,
          footerClass: "p-2",
          centered: true,
        })
        .then((value) => {
          if (value) {
            me.deleteParametroVitale(item.id);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    deleteParametroVitale(id) {
      let me = this;
      UtilityMixin.methods.deleteResource(me.pathResource + "/" + id, me.jsonData, me.onDeleteParametroVitaleSuccess, me.onDeleteParametroVitaleError);
    },
    onDeleteParametroVitaleSuccess(response) {
      let me = this;
      me.$emit("deleteParametroVitale", response);
      me.$bvToast.toast("Eliminazione avvenuta con successo", {
        title: "Successo",
        variant: "success",
        solid: true,
      });
    },
    onDeleteParametroVitaleError(response) {
      let me = this;
      me.$emit("deleteParametroVitale", response);
      me.$bvToast.toast("Errore durante l'eliminazione", {
        title: "Errore",
        variant: "danger",
        solid: true,
      });
    },
  },
};
</script>
